// ParentDocuments.js
import React, { useEffect, useState } from 'react';
import API from './api';

function ParentDocuments() {
  const [myDocs, setMyDocs] = useState([]);

  useEffect(() => {
    fetchMyDocs();
  }, []);

  const fetchMyDocs = async () => {
    try {
      const res = await API.get('/documents/parent/me');
      setMyDocs(res.data || []);
    } catch {
      setMyDocs([]);
    }
  };

  const handleDownload = async (docId, filename) => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`/api/documents/download/${docId}`, {
        headers: { Authorization: token }
      });
      if (!res.ok) throw new Error('Failed to download file');
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename || 'file';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      alert('Download failed!');
    }
  };

  const fmtDate = v => (v ? String(v).replace('T', ' ').slice(0, 16) : '');

  return (
    <div className="p-2 md:p-6 max-w-2xl mx-auto">
      <h2 className="text-lg font-bold mb-3 text-center">My Documents</h2>

      <div className="bg-white rounded-lg p-3 shadow mb-6">
        <div className="overflow-x-auto">
          <table className="min-w-full text-xs border border-gray-300 rounded">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-2">Type</th>
                <th className="p-2">File</th>
                <th className="p-2">Date</th>
              </tr>
            </thead>
            <tbody>
              {myDocs.map(doc => (
                <tr key={doc.id} className="border-t">
                  <td className="p-2">{doc.doc_type}</td>
                  <td className="p-2">
                    <button
                      onClick={() =>
                        handleDownload(doc.id, doc.file_path.split('/').pop())
                      }
                      className="text-blue-700 underline font-medium"
                    >
                      Download
                    </button>
                  </td>
                  <td className="p-2">{fmtDate(doc.uploaded_at)}</td>
                </tr>
              ))}
              {myDocs.length === 0 && (
                <tr>
                  <td colSpan={3} className="text-center text-gray-400 py-4">
                    No documents yet
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ParentDocuments;


